import { track } from '@amplitude/analytics-browser';
import { z } from 'zod';

import { isAnalysisEnabled } from './analysis';

// 自動計測されるものに追加で手動計測する分析イベントのリスト
export const analysisEventKey = {
  SIGNED_IN: 'signed_in',
  SIGNED_OUT: 'signed_out',
  // 検収員の変更
  INSPECTOR_UPDATED: 'inspector_updated',
  // モーダルの表示
  MODAL_SHOWN: 'modal_shown',
  // ページがシステムによって画面遷移された (router.push, router.redirect)
  PAGE_REDIRECTED: 'page_redirected',
  // ページがシステムによって再読み込みされた (router.reload)
  PAGE_RELOADED: 'page_reloaded',
  // 検収開始処理がシステムによって開始された
  ASSESSMENT_START_TRIGGERED: 'assessment_start_triggered',

  // 以下システム系のイベント
  // GraphQL Query の実行
  GRAPHQL_QUERY_SUCCEEDED: 'graphql_query_succeeded',
  GRAPHQL_QUERY_FAILED: 'graphql_query_failed',
  // GraphQL Query (polling) の実行が成功し、イベントを受け取った
  GRAPHQL_QUERY_POLLING_EVENT_RECEIVED: 'graphql_query_polling_event_received',
  // GraphQL Query (polling) の実行失敗 (成功は数が多すぎるので記録しない)
  GRAPHQL_QUERY_POLLING_FAILED: 'graphql_query_polling_failed',
  // GraphQL Mutation の実行
  GRAPHQL_MUTATION_SUCCEEDED: 'graphql_mutation_succeeded',
  GRAPHQL_MUTATION_FAILED: 'graphql_mutation_failed',
  // ConnectionCheck の失敗
  CONNECTION_CHECK_FAILED: 'connection_check_failed',
  CONNECTION_CHECK_RECOVERED: 'connection_check_recovered',
  // Slack にメッセージを送信した
  SLACK_WEBHOOK_SENT: 'slack_webhook_sent',
};
const analysisEventKey_Enum = z.enum([
  analysisEventKey.SIGNED_IN,
  analysisEventKey.SIGNED_OUT,
  analysisEventKey.INSPECTOR_UPDATED,
  analysisEventKey.MODAL_SHOWN,
  analysisEventKey.PAGE_REDIRECTED,
  analysisEventKey.SLACK_WEBHOOK_SENT,
  analysisEventKey.GRAPHQL_QUERY_SUCCEEDED,
  analysisEventKey.GRAPHQL_QUERY_FAILED,
  analysisEventKey.GRAPHQL_QUERY_POLLING_EVENT_RECEIVED,
  analysisEventKey.GRAPHQL_QUERY_POLLING_FAILED,
  analysisEventKey.GRAPHQL_MUTATION_SUCCEEDED,
  analysisEventKey.GRAPHQL_MUTATION_FAILED,
  analysisEventKey.CONNECTION_CHECK_FAILED,
  analysisEventKey.CONNECTION_CHECK_RECOVERED,
]);
type AnalysisEventKey = z.infer<typeof analysisEventKey_Enum>;

export const trackAnalysisEvent = (
  eventKey: AnalysisEventKey,
  properties: Record<string, unknown> = {},
) => {
  if (!isAnalysisEnabled()) return;

  track(eventKey, properties);
};
